import {
  StyleSheet,
  Text,
  View,
  TextInput,
  Image,
  TouchableOpacity,
  SafeAreaView,
  FlatList,
} from "react-native";
import React from "react";

// import { useTranslation } from "react-i18next";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import Appstyles from "../../Constants/AppStyles";
import AppFonts from "../../Constants/AppFonts";
import { DefaultRepo, VehicleList } from "../../Constants/Data";

const ScheduledReports = () => {
  // const { t, i18n } = useTranslation();
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      <View
        style={{ flex: 1, backgroundColor: AppColors.white, marginTop: 20 }}
      >
        <View style={styles.TExtinputView}>
          <TextInput
            placeholder={t("common:translation.Search Vehicle....")}
            placeholderTextColor="#ACACAC80"
            style={styles.TExtinput}
          />

          <View style={styles.vee}>
            <Image
              source={AppImages.search}
              style={styles.im}
              resizeMode="contain"
            />
          </View>
          <TouchableOpacity style={styles.too}></TouchableOpacity>

          <View style={styles.ExImport}>
            <Image
              source={AppImages.Shareit}
              style={styles.ha}
              resizeMode="contain"
            />
          </View>
        </View>

        <View style={{ flex: 1 }}>
          <FlatList
            showsHorizontalScrollIndicator={false}
            ListFooterComponent={() => <View style={{ padding: 10 }} />}
            data={DefaultRepo}
            renderItem={({ item }) => (
              <View
                style={{
                  backgroundColor:
                    item.id == 1 ? AppColors.sandal : AppColors.white,
                  marginHorizontal: 20,
                  marginTop: 20,
                  paddingVertical: 20,
                  borderRadius: 15,
                  borderWidth: 1.5,
                  borderColor: AppColors.sandal,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    { borderBottomWidth: 1, borderBottomColor: "#9C49001A" },
                  ]}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      marginHorizontal: 20,
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <View
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <Image
                        source={item.img}
                        style={{ width: 50, height: 50, borderRadius: 40 }}
                        resizeMode="cover"
                      />
                      <View style={{ marginLeft: 35 }}>
                        <Text
                          style={{
                            color: AppColors.brown1,
                            opacity: 0.6,
                            fontSize: 12,
                            fontFamily: AppFonts.OverpassRegular,
                          }}
                        >
                          Report Name
                        </Text>
                        <Text
                          style={{
                            color: "#8F4300",
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                          }}
                        >
                          {item.title}
                        </Text>
                      </View>
                    </View>
                    <Image
                      source={
                        item.id == 1 ? AppImages.subRepo : AppImages.lookRepo
                      }
                      style={{ height: 20.5, width: 20.2, resizeMode: "cover" }}
                    />
                  </View>
                </View>
                <View
                  style={{
                    marginHorizontal: 20,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <View style={{ width: "75%" }}>
                    <View
                      style={{
                        marginBottom: 10,
                        marginTop: 10,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          opacity: 0.6,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassRegular,
                        }}
                      >
                        No. of Reports
                      </Text>
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        {item.No}
                      </Text>
                    </View>
                    <View style={{}}>
                      <Text
                        style={{
                          color: AppColors.brown1,
                          opacity: 0.6,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassRegular,
                        }}
                      >
                        Last Updated On
                      </Text>
                      <Text
                        style={{
                          color: AppColors.brown1,
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                        }}
                      >
                        {item.date}
                      </Text>
                    </View>
                  </View>
                  <View style={{ alignItems: "flex-end", marginTop: 15 }}>
                    <Image
                      source={AppImages.reportDoc}
                      style={{ height: 90, width: 90, resizeMode: "cover" }}
                    />
                  </View>
                </View>
              </View>
            )}
          />
        </View>
      </View>
    </SafeAreaView>
  );
};

export default ScheduledReports;

const styles = StyleSheet.create({
  TExtinputView: {
    flexDirection: "row",

    justifyContent: "space-between",

    alignItems: "center", // backgroundColor:"aqua",

    marginTop: 20, // height: height * 0.04,
    marginHorizontal: 20,
  },

  TExtinput: {
    fontSize: 12,

    alignItems: "center",

    fontFamily: AppFonts.OverpassMedium,

    width: "90%",

    borderRadius: 10,

    borderColor: AppColors.sandal, // height: height * 0.05,

    borderWidth: 1,

    paddingLeft: 20,

    flexDirection: "row",

    borderRadius: 8,

    justifyContent: "space-between",

    shadowColor: "#000001A",

    shadowOffset: { width: 1, height: 2 },

    shadowOpacity: 0.1,

    shadowRadius: 1, // elevation: 6,
  },

  ExImport: { flexDirection: "row" },

  Flatmain: {
    marginTop: 20, // backgroundColor:"red",

    backgroundColor: "#F6EFE9",

    borderRadius: 10,
  },
  ha: { width: 22, height: 22, marginLeft: 10 },
  ims: { width: 22, height: 22 },
  too: { alignSelf: "flex-end", justifyContent: "center" },
  vee: {
    alignItems: "flex-end",

    justifyContent: "center",

    flex: 1,
  },
  im: { width: 20, height: 20, marginRight: 30 },
});
